import { PopupMenu, Button, Snack } from '@tblabs/truffle';
import { DangerButton } from '../../Components/General/Buttons/DangerButton';
import { Translations } from '../../Translations/Translations';
import { Center } from '../../Components/General/Center';
import { ReceiverLogic } from '../../Logic/ReceiverLogic';


export class CameraOptionsMenu extends PopupMenu
{
    constructor(
        private _lang: Translations,
        private _logic: ReceiverLogic)
    {
        const button = new Button("⁝").Class("uk-button camera-options-button");
        const menu = {
            [_lang.HaltTransmission]: () => this.HaltCamera(),
        };

        super(menu, button);
        this.Style("border: none")

        this.DisplayInlineBlock();
    }

    private HaltCamera(): void
    {
        this._logic.HaltCamera();

        const snack = new Snack("Wysłano komendę zatrzymania transmisji", ["Od teraz kamera zaprzestanie nadawania obrazu.\nWzbudzić ją może kliknięcie przycisku 'Przywróć podgląd'",
            new Center(
                new DangerButton(this._lang.RestorePreview).OnClick(() =>
                {
                    this._logic.LivePreviewMode();
                    snack.Close();
                })
            ).MarginTop(16),
        ], { autoCloseTimeout: 6000 });
    }
}
